import { Card, CardContent, Typography, Box } from '@mui/material';
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid
} from 'recharts';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const formatMonth = (value) => dayjs(value).format('MMM YYYY');

const TooltipContent = ({ active, payload, label }) => {
    if (!active || !payload) return null;

    return (
        <Box
            sx={{
                backgroundColor: '#fff',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                p: 1
            }}
        >
            <Typography variant="caption" color="text.secondary">
                {formatMonth(label)}
            </Typography>
            {payload.map((item) => (
                <Typography
                    key={item.dataKey}
                    variant="body2"
                    sx={{ color: item.stroke }}
                >
                    {item.name}: {item.value.toLocaleString()}
                </Typography>
            ))}
        </Box>
    );
};

const PlatformEvolutionCard = ({ data }) => {
    const { t } = useTranslation();

    return (
        <Card
            sx={{
                height: '100%',
                borderRadius: 0
            }}
        >
            <CardContent sx={{ height: '100%' }}>
                <Typography variant="h3" fontWeight={700} color="primary" gutterBottom>
                    {t('management.platformEvolution')}
                </Typography>

                <Box sx={{ width: '100%', height: 300 }}>
                    <ResponsiveContainer>
                        <LineChart data={data}>
                            <CartesianGrid
                                strokeDasharray="3 3"
                                vertical={false}
                                stroke="#f0f0f0"
                            />

                            <XAxis
                                dataKey="month"
                                tickFormatter={formatMonth}
                                axisLine={false}
                                tickLine={false}
                                interval="preserveStartEnd"
                                ticks={[data[0]?.month, data[data.length - 1]?.month]}
                                style={{ fill: '#9e9e9e', fontSize: 12 }}
                            />

                            <YAxis yAxisId="patients" hide />
                            <YAxis yAxisId="clinics" hide />
                            <YAxis yAxisId="exercises" hide />

                            <Tooltip content={<TooltipContent />} />
                            <Legend />

                            <Line
                                yAxisId="clinics"
                                type="monotone"
                                dataKey="clinics"
                                name={t('management.clinicsLabel')}
                                stroke="#0A579B"
                                strokeWidth={2.5}
                                dot={false}
                            />

                            <Line
                                yAxisId="patients"
                                type="monotone"
                                dataKey="patients"
                                name={t('management.patientsLabel')}
                                stroke="#1976d2"
                                strokeWidth={2.5}
                                dot={false}
                            />

                            <Line
                                yAxisId="exercises"
                                type="monotone"
                                dataKey="exercises"
                                name={t('management.exercises')}
                                stroke="#63a4ff"
                                strokeWidth={2.5}
                                dot={false}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </Box>
            </CardContent>
        </Card>
    );
};

export default PlatformEvolutionCard;
